export default {
  SET_ENTRANCE_LAYOUT: 'SET_ENTRANCE_LAYOUT',
};
